<template>
  <b-card class="m-3">
    <template #header>
      <h6 class="mb-0 text-center">
        <span class="titulo-sagres font-weight-bold">Solicitações de Assinatura</span>
        <b-button class="float-right m-1" size="sm" @click="verHistoricoAssinaturas()">
          <font-awesome-icon icon="history" class="mr-2" />Ver histórico de assinaturas
        </b-button>
      </h6>
    </template>
    <b-row class="up-data">
      <b-col cols="8" class=""></b-col>
      <b-col cols="4" class="">
        <b-input-group size="md">
          <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Pesquisar"></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table :busy="isBusy" :fields="fields" :filter="filter" :filter-included-fields="filterOn" hover
      no-border-collapse :items="items" :sort-desc="true" striped small :per-page="perPage" :current-page="currentPage"
      show-empty>
      <template #empty>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #emptyfiltered>
        <span>Não foram encontrados dados.</span>
      </template>
      <template #table-busy>
        <div class="text-center text-dark">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="loading-text">Carregando...</strong>
        </div>
      </template>
      <template v-slot:cell(actions)="row">
        <div v-if="false">
          <span class="">{{}}</span>
        </div>
        <div v-else class="actions-icons">
          <div class="wrapper-icon" @click="verDetalhes(row.item)">
            <font-awesome-icon icon="eye" />
            <div style="font-size: 12px">Ver Detalhes</div>
          </div>
          <btn-download :fazerDownload="baixarArquivo" texto="Baixar Arquivo" :parametros="row.item" />
        </div>
      </template>
    </b-table>
    <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="perPage" @pageChange="pageChange">
    </table-pagination>
  </b-card>
</template>

<script>
import solicitacoesAssinaturaService from "@/services/processos-eletronicos/solicitacoesAssinaturaService"
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import BtnDownload from "@/components/shared/btn-download.vue";
import { UtilsTS } from '@/utilsts';

export default {
  name: "listar-solicitacoes-assinatura",
  mixins: [UtilsTS],
  components: {
    TablePagination,
    BtnDownload
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      totalRows: null,
      isBusy: false,
      filter: null,
      filterOn: ["CodProtProc", "Assunto", "NomeArquivo"],
      fields: [
        {
          key: "CodProtProc",
          label: "Protocolo/Processo",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "Assunto",
          label: "Assunto",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "NomeArquivo",
          label: "Nome do arquivo",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
          sortable: true,
        },
      ],
      items: [],
    }
  },
  methods: {
    pageChange(value) {
      this.currentPage = value;
    },

    async buscarAssinaturas() {
      this.isBusy = true
      const response = await solicitacoesAssinaturaService.buscarAssinaturas()
      if (response) {
        if (response.status == 200) {
          this.items = response.data
          this.totalRows = this.items.length
        }
        else {
          this.$toast.error(response.data.msg)
        }
      }
      else {
        this.$toast.error("Erro ao buscar assinaturas")
      }

      this.isBusy = false
    },

    async verDetalhes(solicitacao) {
      this.$router.push({
        name: "processo-eletronico--detalhes-solicitacao-assinatura",
        params: {
          solicitacao,
        }
      })
    },

    async baixarArquivo(item) {
      const response = await solicitacoesAssinaturaService.baixarArquivoAssinatura(item.CodArquivoDigital)
      if (response && response.status == 200) {
        this.download(item.NomeArquivo, response.data);
      } else {
        if (response && response.status === 404)
          this.$toast.error("Erro ao obter o arquivo");
        else if (response.data.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Erro ao obter o arquivo");
      }
    },

    async verHistoricoAssinaturas() {
      this.$router.push('/processo-eletronico/historico-solicitacoes-assinatura')
    }
  },
  async mounted() {
    await this.buscarAssinaturas()
  }
}
</script>
